module.exports = wtr_shared_18_12_2;